import React, { useContext, useEffect } from 'react';
import AuthLayout from '../../components/auth-layout';
import { featureFlagsContext } from '../../providers/FeatureFlagsProvider';
import { navigate } from 'gatsby';
import routes from '../../routes';
import useInvoicePaymentAuth from '../../hooks/invoice-payment-portal/useInvoicePaymentAuth';
import InvoicePaymentForgotPassword from '../../components/invoice-payment-portal/auth/ForgotPassword';

export default function Auth() {
  
  const { isAuthenticated } = useInvoicePaymentAuth();

  useEffect(() => {
        if (isAuthenticated) {
            void navigate(routes.INVOICE_PAYMENT_PORTAL_INVOICE_LIST);        
        }    
    }, []);
  
  
  return isAuthenticated ? null : (
    <AuthLayout footer={<></>} showLeft={false}>
      <InvoicePaymentForgotPassword />
    </AuthLayout>
  );
}
